import { FC } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { Landing } from './pages';

export interface MatchParams {
  identifier?: string;
}

const Routes: FC = () => (
  <BrowserRouter>
    <Switch>
      <Route component={Landing} path="/u/:identifier" />
      <Route component={Landing} path="/" />
    </Switch>
  </BrowserRouter>
);

export default Routes;
